import type { AdminDemoAsset } from '../types/admin-demo';

/** Never substitute English footage on a Chinese page (or vice versa). */
export function localizedAdminDemos(
  assets: readonly AdminDemoAsset[],
  language: 'en' | 'zh'
): AdminDemoAsset[] {
  const captureLanguage = language === 'zh' ? 'cn' : 'en';
  return assets.filter(asset => asset.language === captureLanguage);
}
